import React, { lazy, useEffect } from 'react';
import { setChatPageContext } from '|/app/purchase/checkout/constants/chat-page-context';
import { getChatSurface } from '|/app/purchase/checkout/constants/chat-surface-mappings';
import { useBrand } from '|/brand';
import registry from '~/library/store/src/registry';

const InsuranceOptionsComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "carvana-purchase-insurance-options" */ '@carvana/purchase-insurance-options'
    ) as unknown as Promise<{ default: React.ComponentType<any> }>
);

const defaultProps = {
  GetDashboardAndRouteToNextStep: (_?: boolean) => {}
};

export const InsuranceOptionsRoute = ({ GetDashboardAndRouteToNextStep } = defaultProps) => {
  const { brand } = useBrand();
  useEffect(() => {
    const surface = getChatSurface('insurance-options', brand);
    if (surface) setChatPageContext(surface);
  }, [brand]);

  return (
    <InsuranceOptionsComponent
      registry={registry}
      dashboardActions={{
        GetDashboardAndRouteToNextStep
      }}
    />
  );
};
